/**
 * Created by JIA on 2020/4/9.
 */
import _ from "lodash";

import BaseSpeechService from "./BaseSpeechService";
import { handleCommonRecognitionResultAutoCheckLanguage } from "./RecognitionService/BaseRecognitionService";
import { recognizeServiceTypeEnum as serviceTypeEnum } from "./SpeechCommonHelper";

//endregion

const baseHandleResult = (internalInfoObj, response, resolve, reject) => {
    //xunfei ASR only return the text result
    let result;
    if (response && response.audioToShort) {
        result = "";
    } else {
        result = _.toString(response);
    }

    const xunfeiASRResult = handleCommonRecognitionResultAutoCheckLanguage(result, internalInfoObj.referenceText, internalInfoObj.syllableArray, internalInfoObj.referenceMarkText);

    if (xunfeiASRResult && xunfeiASRResult.shouldResolve) {
        resolve(xunfeiASRResult.result);
    } else {
        reject({
            code: "error",
            message: xunfeiASRResult.rejectMessage,
        });
    }
};

const commonHandleResult = (internalInfoObj, response, resolve, reject) => {
    //do some convert for response since the native code return raw json back
    try {
        switch (internalInfoObj.recognizeServiceType) {
            case serviceTypeEnum.XunFeiASR:
                baseHandleResult(internalInfoObj, response, resolve, reject);
                break;
            case serviceTypeEnum.XunFeiIAT:
                baseHandleResult(internalInfoObj, response, resolve, reject);
                break;
            case serviceTypeEnum.AliYunIAT:
                baseHandleResult(internalInfoObj, response, resolve, reject);
                break;
            case serviceTypeEnum.AliYunIntIAT:
                baseHandleResult(internalInfoObj, response, resolve, reject);
                break;
            case serviceTypeEnum.AzureIAT:
                baseHandleResult(internalInfoObj, response, resolve, reject);
                break;
            default:
                resolve(response);
                break;
        }
    } catch (e) {
        reject(e);
    }
};

const SpeechRecognition = {
    ...BaseSpeechService,
    init: config => {
        config.forReview = false;
        config.recognizeServiceType = config.serviceType;
        config.customHandler = {
            setReferenceSyllables: () => {},
            setReferenceText: () => {},
            handleResult: commonHandleResult,
        };
        return BaseSpeechService.init(config);
    },
    initWithoutKey: config => {
        config.forReview = false;
        config.customHandler = {
            setReferenceSyllables: () => {},
            setReferenceText: () => {},
            handleResult: commonHandleResult,
        };
        return BaseSpeechService.initWithoutKey(config);
    },
    lastConfig: () => {
        return BaseSpeechService.lastConfig;
    },
};

SpeechRecognition.propTypes = BaseSpeechService.propTypes;

export default SpeechRecognition;
